import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useProductsLazyQuery } from "../../../saleor/api";
import { Input, Note, Page } from "../../../helbest";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import { ReactComponent as SearchIconSvg } from "../../../assets/svg/search.svg";
import { mapEdgesToNodes } from "../../../base/utils";
import { ProductTransformer } from "../../../services/objectTransformer/products";
import styles from "./ProductSearch.module.css";
import { ProductItem } from "../../components";
import Loading from "../../components/Loading/Loading";
import _ from "lodash";
import { useSelector } from "react-redux";

export default function ProductSearch() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const { t, i18n } = useTranslation();
  const search = searchParams.get("q") || "";
  const { channel } = useSelector((state) => state.Login);

  const [trigger, { loading }] = useProductsLazyQuery({
    variables: {
      channel,
      filter: {
        search: search,
      },
      first: 100,
      lng: i18n.language.toUpperCase(),
    },
    onCompleted(response) {
      setProducts(response.products.edges);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    onError(error) {
      Note.error(error.message);
    },
  });

  useEffect(() => {
    if (search.length >= 3) {
      trigger({
        channel,
        filter: {
          search: search,
        },
        first: 100,
      });
    }
  }, [search]);

  const debouncedSearchFn = useCallback(
    _.debounce((value) => {
      setSearchParams({ q: value });
    }, 500),
    [],
  );

  return (
    <>
      <Page
        customHeader={
          <HeaderBack
            title={
              <div className={styles.searchContainer}>
                <Input
                  defaultValue={search}
                  allowClear={false}
                  className="search-input"
                  type="text"
                  placeholder={t("searchproducts.placeholder")}
                  dataHandler={(value) => {
                    debouncedSearchFn(value);
                  }}
                />
                <div className="search-box">
                  <SearchIconSvg className="button-search" />
                </div>
              </div>
            }
            url={"/"}
          />
        }
        headerFix
      >
        <div className={styles.container}>
          {loading && (
            <div className="mt-5 mb-3 text-center">
              <Loading />
            </div>
          )}
          {search.length >= 3 &&
            mapEdgesToNodes(products, ProductTransformer)?.map((result, i) => {
              return (
                <React.Fragment key={i}>
                  <ProductItem
                    id={result.id}
                    key={i}
                    data={result}
                    set_show_footer={() => {}}
                  />
                </React.Fragment>
              );
            })}
          {(!loading &&
            !mapEdgesToNodes(products, ProductTransformer).length) ||
          search.length <= 3 ? (
            <div
              className="text-center"
              style={{ marginTop: "16px", width: "100%" }}
            >
              <span style={{ color: "#959595" }}>
                {t("searchproducts.no_found")}
              </span>
            </div>
          ) : null}
        </div>
      </Page>
    </>
  );
}
